
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[categoryHandle]",
      function () {
        return require("private-next-pages/shop/[categoryHandle]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[categoryHandle]"])
      });
    }
  